import styled from 'styled-components'


export const ZoomPopupWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top:0px;
  left: 0px;
  z-index: 10;
  /* opacity: ${({ isVisible }) => (isVisible ? "1" : "0")}; */
  /* display: ${({ isVisible }) => (isVisible ? "flex" : "none")}; */
  justify-content: center;
  align-items: center;
  border: 2px solid gray;
  border-radius: 6px;
  height: 100%;
  width: 180px;
  background-color: #fff;
  overflow: hidden;
  transition: all 300ms ease-in-out;
  transform: translateX(-10px) scale(${({ isVisible }) => (isVisible ? "1" : "0")});
  padding-top: 14px;
  box-sizing: border-box;
  img {
    width: 100%;
    height: auto;
    aspect-ratio: auto;
  }


`;

export const ImgWrapper = styled.div`
  position: relative;
  /* display: inline-block; */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    /* width: 100px;  */
    /* height: auto; */
    cursor: pointer;
  }
`;